export const chooses = [
  {
    number: 2600,
    name: "Students Successive",
    desc: "Throughout these year we have done amazing ",
    link:"work with 250 students.. "
  },
  {
    number: 5900,
    name: "Competitions Won ",
    desc: "Only competitions were the ones in the back",
    link:" of the magazines you find.."
  },
  {
    number: 8400,
    name: "Classes Visited ",
    desc: "Can how you setup your classroom impact ",
    link:"how students think..."
  },
];
